import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
const failures = ['Escuchar el consejo de "no tengas tarjetas de crédito" te deja sin historial, impidiéndote comprar una casa o un auto con bajos intereses en el futuro.', 'Seguir las tendencias de "dinero fácil" de TikTok te hace perder tus ahorros en apuestas arriesgadas en lugar de construir riqueza sólida.', 'Ahorrar sin invertir garantiza que la inflación se coma el valor de tu trabajo año tras año.', 'Intentar "ayudar a la familia" sin tener tus propias finanzas blindadas te hunde a ti y a ellos al mismo tiempo.'];
export function WhyItFailed() {
  return <section className="py-24 px-6 bg-[#0f0f0f]" data-id="element-193">
      <div className="max-w-4xl mx-auto" data-id="element-194">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-195">
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-196">
            Lo Que Ya Intentaste No Funciona
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-197">
            El sistema está diseñado para que cometas estos errores.
          </p>
        </motion.div>

        <div className="space-y-4" data-id="element-198">
          {failures.map((text, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 p-6 bg-dark border border-white/5 rounded-xl hover:bg-white/[0.02] transition-colors" data-id="element-199">
              <XCircleIcon className="w-6 h-6 text-red-500 shrink-0 mt-1" data-id="element-200" />
              <p className="text-lg text-gray-300 leading-relaxed" data-id="element-201">{text}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}